import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Card, Menu, MenuDivider, MenuItem, Popover, PopoverPosition, Spinner, Tooltip, } from "@blueprintjs/core";
import { mdiAccountArrowRightOutline, mdiAccountCowboyHat, mdiAlertOutline, mdiCheck, mdiCog, mdiExclamation, mdiExport, mdiImport, mdiMenuUp, } from "@mdi/js";
import { LG } from "big-l";
import classNames from "classnames";
import { format } from "date-fns";
import { App, Auth, HTTP } from "katal3-client";
import { Component } from "react";
import { connect } from "react-redux";
import { ComponentUtils } from "../utils/ComponentUtils";
import { DebugWindow } from "./DebugWindow";
import IKon from "./IKon";
const LGR = LG.ns("StatusBar");
// LGR.enabled = false;
const RUNNING_IO_UPDATE_INTERVAL = 15100;
const STALLED_IO_UPDATE_INTERVAL = 120100;
const defaultStatusBarState = {
    debug: false,
    screenshot: false,
    showIOs: false,
    ios: [],
    ioFail: false,
    ioRun: false,
    ioWork: false,
};
const IO_LABELS = {
    [HTTP.Katal.IO.Type.ARTICLES]: "Articles",
    [HTTP.Katal.IO.Type.MONTH_HISTORY]: "Historique mois",
    [HTTP.Katal.IO.Type.WEEK_HISTORY]: "Historique sem.",
    [HTTP.Katal.IO.Type.STOCKS]: "Stocks",
    [HTTP.Katal.IO.Type.ORDERS]: "Commandes",
    [HTTP.Katal.IO.Type.PROVIDERS]: "Fournisseurs",
    [HTTP.Katal.IO.Type.TILL]: "Caisses",
    [HTTP.Katal.IO.Type.PRICE_UPDATES]: "Prix TARO",
    [HTTP.Katal.IO.Type.RESULTS]: "Résultats",
};
class StatusBar extends Component {
    constructor() {
        super(...arguments);
        this.state = defaultStatusBarState;
    }
    componentDidMount() {
        if (this.props.user)
            this.props.getStatus(this.props.module);
    }
    componentWillUnmount() {
        if (this.updateTimeout)
            clearTimeout(this.updateTimeout);
    }
    shouldComponentUpdate(nextProps, nextState) {
        const { propsDiff, stateDiff } = ComponentUtils.diff(this, nextProps, nextState);
        if ((propsDiff.module || propsDiff.user || propsDiff.ready) && nextProps.user) {
            this.props.getStatus(nextProps.module);
        }
        if (propsDiff.ios) {
            let ioFail = false, ioDate, ioRun = false, ioWork = false;
            for (const st of nextProps.ios) {
                if (st.type) {
                    if (st.fail)
                        ioFail = true;
                    if (st.running)
                        ioRun = true;
                    if (!ioDate || (st.success && st.success > ioDate))
                        ioDate = st.success;
                }
                else {
                    ioWork = st.running;
                }
            }
            this.setState({
                ios: [...nextProps.ios]
                    .filter((i) => !!i.type)
                    .sort((io1, io2) => (IO_LABELS[io1.type] > IO_LABELS[io2.type] ? 1 : -1)),
                ioFail,
                ioDate,
                ioRun,
                ioWork,
            });
            if (nextProps.user) {
                this.refreshIOStatus(nextProps.module, ioRun || ioWork ? RUNNING_IO_UPDATE_INTERVAL : STALLED_IO_UPDATE_INTERVAL);
            }
            return false;
        }
        return true;
    }
    refreshIOStatus(module, nextDelay) {
        return;
        if (this.updateTimeout)
            clearTimeout(this.updateTimeout);
        LGR.debug("Refresh in", nextDelay, "ms.");
        if (this.props.user)
            this.updateTimeout = setTimeout(() => this.props.getStatus(module), nextDelay);
    }
    render() {
        var _a, _b;
        const { config, user, loading, working, loadings, module } = this.props;
        const { debug, screenshot, showIOs, ios, ioFail, ioDate, ioRun, ioWork } = this.state;
        const modules = Object.values((user === null || user === void 0 ? void 0 : user.modules) || {}).filter((mod) => mod.uid !== module);
        LGR.info("Loading", loading, loadings);
        return (_jsxs("div", Object.assign({ id: "status-bar" }, { children: [debug ? _jsx(DebugWindow, { onClose: () => this.setState({ debug: false }) }, void 0) : null, _jsxs("div", Object.assign({ className: "menu" }, { children: [module ? (_jsxs(Popover, Object.assign({ minimal: true, position: PopoverPosition.TOP_LEFT, disabled: !modules.length, popoverClassName: classNames("status-popover") }, { children: [_jsx(Button, Object.assign({ className: "module-button", rightIcon: modules.length ? _jsx(IKon, { icon: mdiMenuUp, size: 14 }, void 0) : undefined }, { children: `${config === null || config === void 0 ? void 0 : config.description} v${config === null || config === void 0 ? void 0 : config.version}` }), void 0), _jsxs(Menu, Object.assign({ className: "module-menu" }, { children: [_jsx(MenuItem, { text: "Katal", icon: _jsx("img", { src: `../favicon.svg`, width: 16 }, void 0), href: `../` }, `home-link`), !!modules.length && _jsx(MenuDivider, {}, void 0), modules.map((mod) => (_jsx(MenuItem, { text: mod.name, icon: _jsx("img", { src: `../${mod.folder}/favicon.svg`, width: 16 }, void 0), href: `../${mod.folder}/` }, `module-link-${mod.uid}`)))] }), void 0)] }), void 0)) : null, loading ? (_jsx(Tooltip, Object.assign({ openOnTargetFocus: false, content: _jsx("div", { children: Object.keys(loadings).map((ldg) => (_jsx("div", { children: ldg }, `loading-${ldg}`))) }, void 0) }, { children: _jsx(Spinner, { className: "loading-status", size: 15 }, void 0) }), void 0)) : null, working ? _jsx(IKon, { className: "working", icon: mdiCog, size: 16 }, void 0) : null] }), void 0), !!ios.length && user && (_jsx("div", Object.assign({ className: "status" }, { children: _jsxs(Popover, Object.assign({ minimal: true, position: PopoverPosition.TOP, disabled: !ios.length, popoverClassName: classNames("status-popover", "io-popover"), isOpen: showIOs, onClose: () => this.setState({ showIOs: false }) }, { children: [_jsxs(Button, Object.assign({ className: "status", icon: ioRun ? (_jsx(Spinner, { size: 14 }, void 0)) : ioWork ? (_jsx(IKon, { className: "working", icon: mdiCog, size: 16 }, void 0)) : ioFail ? (_jsx(IKon, { icon: mdiAlertOutline, size: 14 }, void 0)) : undefined, onClick: () => {
                                    this.setState({ showIOs: !showIOs });
                                    if (!showIOs) {
                                        this.refreshIOStatus(module, ioRun || ioWork ? RUNNING_IO_UPDATE_INTERVAL : STALLED_IO_UPDATE_INTERVAL);
                                    }
                                } }, { children: ["Donn\u00E9es", ioDate ? ` du ${format(ioDate, "dd/MM")}` : null] }), void 0), _jsx(Card, { children: ios
                                    .filter((i) => !!i.type)
                                    .map((io) => (_jsxs("div", { children: [io.running ? (_jsx(Spinner, { size: 14 }, void 0)) : io.fail ? (_jsx(IKon, { icon: mdiExclamation, size: 16, className: "fail" }, void 0)) : io.success ? (_jsx(IKon, { icon: mdiCheck, size: 16, className: "success" }, void 0)) : null, io.direction == HTTP.Katal.IO.Direction.IN ? (_jsx(IKon, { icon: mdiImport, size: 14 }, void 0)) : io.direction == HTTP.Katal.IO.Direction.OUT ? (_jsx(IKon, { icon: mdiExport, size: 14 }, void 0)) : null, _jsx("span", Object.assign({ className: "label" }, { children: IO_LABELS[io.type] }), void 0), _jsx("span", Object.assign({ className: "date" }, { children: io.success ? format(io.success, "dd/MM") : "---" }), void 0)] }, `${io.type}`))) }, void 0)] }), void 0) }), void 0)), _jsxs("div", Object.assign({ className: "user" }, { children: [(user === null || user === void 0 ? void 0 : user.isDev()) ? (_jsx(_Fragment, { children: _jsx(Button, { className: "dev", icon: _jsx(IKon, { icon: mdiAccountCowboyHat, size: 16 }, void 0), onClick: () => this.setState({ debug: true }) }, void 0) }, void 0)) : null, user ? (_jsxs(_Fragment, { children: [_jsxs("span", { children: ["Utilisateur: ", (_a = user.profile) === null || _a === void 0 ? void 0 : _a.firstName, " ", (_b = user.profile) === null || _b === void 0 ? void 0 : _b.lastName.toUpperCase()] }, void 0), _jsx(Button, { className: "logout", icon: _jsx(IKon, { icon: mdiAccountArrowRightOutline, size: 16 }, void 0), onClick: () => this.props.logout() }, void 0)] }, void 0)) : null] }), void 0)] }), void 0));
    }
}
const mapState = (state) => ({
    user: state.auth.user,
    ready: state.app.ready,
    module: state.auth.module,
    loading: state.app.loading,
    loadings: state.app.loadings,
    working: state.app.working,
    config: state.app.localConfig,
    ios: state.app.ios,
});
const mapDispatch = (dispatch) => ({
    logout: () => dispatch(Auth.logout()),
    getStatus: (module) => dispatch(App.getStatus(module)),
});
const connector = connect(mapState, mapDispatch);
export default connector(StatusBar);
